module.exports = __webpack_public_path__ + "img/telegram-icon.6b57126b.svg";